const load = (src) => new Promise((res, rej) => { const i = new Image(); i.onload = () => res(i); i.onerror = rej; i.src = src; });

function drawSpaced(x, text, cx, y, spacing) {
  x.textAlign = "left";
  const widths = [...text].map((ch) => x.measureText(ch).width);
  const total = widths.reduce((a, b) => a + b, 0) + spacing * (text.length - 1);
  let px = cx - total / 2;
  [...text].forEach((ch, i) => { x.fillText(ch, px, y); px += widths[i] + spacing; });
  x.textAlign = "center";
}

export async function shareDishCard(data) {
  const A = data.assets || {};
  await Promise.all([
    document.fonts.load("800 96px Outfit"),
    document.fonts.load("700 30px Manrope"),
    document.fonts.load("italic 500 40px Manrope"),
  ]).catch(() => {});
  const [scene, hero] = await Promise.all([
    A.scene ? load(A.scene).catch(() => null) : null,
    load(A.hero || data.dish.image),
  ]);
  const W = 1080, H = 1350;
  const c = document.createElement("canvas");
  c.width = W;
  c.height = H;
  const x = c.getContext("2d");
  x.fillStyle = "#050505";
  x.fillRect(0, 0, W, H);
  if (scene) {
    const s = Math.max(W / scene.width, H / scene.height);
    x.globalAlpha = 0.85;
    x.drawImage(scene, (W - scene.width * s) / 2, (H - scene.height * s) / 2, scene.width * s, scene.height * s);
    x.globalAlpha = 1;
  }
  const g = x.createLinearGradient(0, 0, 0, H);
  g.addColorStop(0, "rgba(0,0,0,0.55)");
  g.addColorStop(0.45, "rgba(0,0,0,0.15)");
  g.addColorStop(1, "rgba(0,0,0,0.92)");
  x.fillStyle = g;
  x.fillRect(0, 0, W, H);
  x.strokeStyle = "rgba(212,175,55,0.85)";
  x.lineWidth = 3;
  x.strokeRect(42, 42, W - 84, H - 84);
  x.textAlign = "center";
  x.fillStyle = "#D4AF37";
  x.font = "700 30px Manrope, sans-serif";
  drawSpaced(x, "URBAN BY VEERGI PRESENTS", W / 2, 152, 12);
  const hw = 760, hh = hero.height * (hw / hero.width);
  x.shadowColor = "rgba(0,0,0,0.7)";
  x.shadowBlur = 60;
  x.shadowOffsetY = 34;
  x.drawImage(hero, (W - hw) / 2, 610 - hh / 2, hw, hh);
  x.shadowColor = "transparent";
  x.shadowBlur = 0;
  x.shadowOffsetY = 0;
  x.fillStyle = "#FFFFFF";
  x.font = "800 96px Outfit, sans-serif";
  x.fillText(data.headline, W / 2, 1085);
  x.fillStyle = "rgba(255,255,255,0.78)";
  x.font = "italic 500 40px Manrope, sans-serif";
  x.fillText(`${data.sub} · $${Number(data.dish.price).toFixed(2)}`, W / 2, 1152);
  x.fillStyle = "#D4AF37";
  x.font = "700 26px Manrope, sans-serif";
  drawSpaced(x, "A CINEMATIC EXPERIENCE · MYURBANPASSPORT.COM", W / 2, 1254, 6);
  const blob = await new Promise((res) => c.toBlob(res, "image/png"));
  const file = new File([blob], `${data.dish.slug}-urban.png`, { type: "image/png" });
  if (navigator.canShare?.({ files: [file] })) {
    try {
      await navigator.share({ files: [file], title: data.headline, text: `${data.headline} at Urban by VeerGi` });
      return "shared";
    } catch (e) {
      if (e.name === "AbortError") return "cancelled";
    }
  }
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = file.name;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 4000);
  return "downloaded";
}
